export type GalleryStatus = 'PENDING' | 'APPROVE' | 'REJECT';

export type GalleryMediaFile = {
  url?: string;
  mediaUrl?: string;
  mediaType?: string;
  type?: string;
  mimeType?: string;
  size?: number;
  orientation?: 'PORTRAIT' | 'LANDSCAPE' | string;
};

export type GalleryMediaEntry = {
  mediaId?: string;
  orientation?: 'PORTRAIT' | 'LANDSCAPE' | string;
  media?: GalleryMediaFile;
};

export type GalleryStatusChangedBy = {
  _id?: string;
  name?: string | null;
  email?: string | null;
  role?: string | null;
  label?: string | null;
};

export type GalleryItem = {
  _id?: string;
  id?: string;
  contentName?: string;
  contentType?: string;
  status?: GalleryStatus | string;
  mediaIds?: GalleryMediaEntry[];
  /** Legacy single-media fallback */
  mediaId?: GalleryMediaFile;
  statusChangedBy?: GalleryStatusChangedBy;
};

export type GalleryListFilter = {
  page: number;
  limit: number;
  status: GalleryStatus;
};

export type GalleryListResponse = {
  success?: boolean;
  message?: string;
  data?: GalleryItem[];
  page?: number;
  totalPages?: number;
  total?: number;
  limit?: number;
};

export type GalleryCounts = {
  pending?: number;
  approved?: number;
  rejected?: number;
};

export type GalleryUploadPayload = {
  contentName: string;
  contentType: string;
  mediaIds: Array<{ mediaId: string; orientation: string }>;
};

export const GALLERY_TABS: Array<{
  key: GalleryStatus;
  label: string;
  countKey: keyof GalleryCounts;
}> = [
  { key: 'PENDING', label: 'Pending', countKey: 'pending' },
  { key: 'APPROVE', label: 'Approved', countKey: 'approved' },
  { key: 'REJECT', label: 'Rejected', countKey: 'rejected' },
];

export function isGalleryVideo(media?: GalleryMediaFile | null) {
  if (!media) return false;
  const url = media.url || '';
  return (
    media.mediaType === 'video' ||
    Boolean(media.type?.startsWith('video')) ||
    Boolean(media.mimeType?.startsWith('video')) ||
    /\.(mp4|webm|ogg|mov)$/i.test(url)
  );
}

export function firstGalleryMedia(item: GalleryItem) {
  return item.mediaIds?.[0]?.media || item.mediaId || null;
}

export function galleryItemId(item: GalleryItem) {
  return String(item._id || item.id || '');
}

export function galleryStatusActorName(item: GalleryItem) {
  const by = item.statusChangedBy;
  if (!by) return '';
  return String(by.name || by.label || by.email || '').trim();
}

export function galleryStatusChangedByText(item: GalleryItem) {
  const status = String(item.status || '').toUpperCase();
  const actor = galleryStatusActorName(item);
  if (!actor) return '';
  if (status === 'APPROVE') return `Approved by ${actor}`;
  if (status === 'REJECT') return `Rejected by ${actor}`;
  return '';
}
